module.exports = __webpack_public_path__ + "static/media/chat.d8cc9e46.svg";